import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const menuPermissionApi = createApi({
    reducerPath: "base/menuPermission",
    baseQuery: axiosBaseQuery,
    tagTypes: ["menuPermissionList"],
    endpoints: (builder) => ({
        menuPermissionFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['menuPermissionList'],
            query: (query = '') => ({
                url: "/base/menuPermission" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        menuPermissionCreate: builder.mutation({
            invalidatesTags: ['menuPermissionList'],
            query: (data) => ({ url: "/base/menuPermission", method: "POST", data })
        }),
        menuPermissionUpdate: builder.mutation({
            invalidatesTags: ['menuPermissionList'],
            query: (data) => ({ url: "/base/menuPermission/" + data.id, method: "PUT", data })
        }),
        menuPermissionDelete: builder.mutation({
            invalidatesTags: ['menuPermissionList'],
            query: (id) => ({ url: "/base/menuPermission/" + id, method: "DELETE" })
        }),
    })
})

export const { useMenuPermissionFindAllQuery, useMenuPermissionCreateMutation, useMenuPermissionUpdateMutation, useMenuPermissionDeleteMutation } = menuPermissionApi;
export { menuPermissionApi };
